import request from "superagent";
import { BACKEND_URL } from "../config/config";
import {
  GeometrySectionType,
  InputSectionType,
  isStoredSection,
} from "../types/Section";
import Survey from "../types/Survey";

export function createSurvey(data: Survey, sessionToken: string) {
  return new Promise<string>((resolve, reject) => {
    request
      .post(BACKEND_URL + "api/survey/v1/surveys")
      .set("Authorization", `Bearer ${sessionToken}`)
      .send(data)
      .then((res) => {
        resolve(res.body.uuid);
      })
      .catch((e) => {
        reject(e.response.body);
      });
  });
}

export function updateSurvey(uuid: string, data: Survey, sessionToken: string) {
  return new Promise<string>((resolve, reject) => {
    request
      .post(BACKEND_URL + `api/survey/v1/surveys/${uuid}`)
      .set("Authorization", `Bearer ${sessionToken}`)
      .send(data)
      .then((res) => {
        resolve(res.body.uuid);
      })
      .catch((e) => {
        reject(e.response.body);
      });
  });
}

export function patchRecord(
  uuid: string,
  id: number,
  data: any,
  sessionToken: string
) {
  return new Promise<void>((resolve, reject) => {
    request
      .patch(BACKEND_URL + `api/features/${uuid}/${id}`)
      .set("Authorization", `Bearer ${sessionToken}`)
      .send({ data, srid: 4326 })
      .then(() => {
        resolve();
      })
      .catch((e) => {
        reject(e.response.body);
      });
  });
}

export function setSurveyPublishedStatus(
  uuid: string,
  newPublishedStatus: boolean,
  sessionToken: string | null
) {
  return new Promise<void>((resolve, reject) => {
    request
      .post(
        BACKEND_URL +
          `api/survey/v1/surveys/${uuid}/${
            newPublishedStatus ? "publish" : "unpublish"
          }`
      )
      .set("Authorization", `Bearer ${sessionToken}`)
      .send()
      .then(() => {
        resolve();
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export function normalizeData(survey: Survey, data: any) {
  const out: any = {};

  for (let name in data) {
    const section = survey.schema.find(
      (s) => isStoredSection(s) && s.columnName === name
    );
    let value = data[name];
    if (name === "geom") {
      name = "geom_wkt";
      if (!value) {
        switch (section?.type) {
          case GeometrySectionType.geometry_line:
            value = "LINESTRING EMPTY";
            break;

          case GeometrySectionType.geometry_point:
            value = "POINT EMPTY";
            break;

          case GeometrySectionType.geometry_polygon:
            value = "POLYGON EMPTY";
            break;
        }
      }
    }
    if (section) {
      switch (section.type) {
        case InputSectionType.multiselect_list:
          if (Array.isArray(value)) value = value.join(",");
          break;
      }
    }
    out[name] = value;
  }

  return out;
}
